if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [];
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchEndX = 0;
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this.handleKeydown);
      }

      show(opener) {
        super.show(opener);
        this.initLightbox();
      }

      initLightbox() {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        if (this.mediaItems.length === 0) return;

        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        this.currentIndex = this.mediaItems.findIndex(
          (el) => el.getAttribute('data-media-id') === openedMediaId
        );
        if (this.currentIndex === -1) this.currentIndex = 0;

        this.showMedia(this.currentIndex);
        this.createNavigation();
        this.bindEvents();
      }

      showMedia(index) {
        this.mediaItems.forEach((el, i) => {
          el.classList.toggle('active', i === index);
        });

        const activeMedia = this.mediaItems[index];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateCounter();
      }

      createNavigation() {
        if (this.querySelector('.lightbox-nav')) return;
        if (this.mediaItems.length <= 1) return;

        const dialog = this.querySelector('.product-media-modal__dialog');

        // Prev button
        const prevBtn = document.createElement('button');
        prevBtn.className = 'lightbox-nav lightbox-nav--prev';
        prevBtn.setAttribute('aria-label', 'Image précédente');
        prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
        prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.prev(); });

        // Next button
        const nextBtn = document.createElement('button');
        nextBtn.className = 'lightbox-nav lightbox-nav--next';
        nextBtn.setAttribute('aria-label', 'Image suivante');
        nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
        nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.next(); });

        // Counter
        const counter = document.createElement('div');
        counter.className = 'lightbox-counter';

        dialog.appendChild(prevBtn);
        dialog.appendChild(nextBtn);
        dialog.appendChild(counter);

        this.updateCounter();
      }

      updateCounter() {
        const counter = this.querySelector('.lightbox-counter');
        if (counter) {
          counter.textContent = `${this.currentIndex + 1} / ${this.mediaItems.length}`;
        }
      }

      prev() {
        this.currentIndex = (this.currentIndex - 1 + this.mediaItems.length) % this.mediaItems.length;
        this.showMedia(this.currentIndex);
      }

      next() {
        this.currentIndex = (this.currentIndex + 1) % this.mediaItems.length;
        this.showMedia(this.currentIndex);
      }

      bindEvents() {
        // Keyboard navigation
        this.handleKeydown = (e) => {
          if (e.key === 'ArrowLeft') this.prev();
          if (e.key === 'ArrowRight') this.next();
        };
        document.addEventListener('keydown', this.handleKeydown);

        // Touch swipe
        const content = this.querySelector('.product-media-modal__content');
        if (!content || content.dataset.swipeBound) return;
        content.dataset.swipeBound = 'true';

        content.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        content.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          const diff = this.touchStartX - this.touchEndX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) this.next();
            else this.prev();
          }
        }, { passive: true });
      }

      // Keep backward compat
      showActiveMedia() {
        this.initLightbox();
      }
    }
  );
}
